import { render } from "./Pejabat.vue?vue&type=template&id=231511ba"
import script from "./Pejabat.vue?vue&type=script&lang=js"
export * from "./Pejabat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__